import { render, staticRenderFns } from "./activity-poster.vue?vue&type=template&id=8a6e50ae&scoped=true&"
import script from "./activity-poster.vue?vue&type=script&lang=js&"
export * from "./activity-poster.vue?vue&type=script&lang=js&"
import style0 from "./activity-poster.vue?vue&type=style&index=0&id=8a6e50ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e50ae",
  null
  
)

export default component.exports